import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import ToggleButton from '../../../../ToggleButton';
import s from './ActionBarToggleButton.scss';
/**
 * Provides our `ToggleButton` with some additional ActionBar specific styling.
 */ const ActionBarToggleButton = (_param)=>{
    var { className, activated, children, icon: Icon } = _param, rest = _object_without_properties(_param, [
        "className",
        "activated",
        "children",
        "icon"
    ]);
    return /*#__PURE__*/ React.createElement(ToggleButton, _object_spread({
        className: c(s['root'], className),
        icon: Icon,
        activated: activated
    }, rest));
};
ActionBarToggleButton.displayName = 'ActionBarToggleButton';
export default ActionBarToggleButton;
